export default __webpack_public_path__ + "static/demand360-lite-product-regular-8be27182aeb56a4589704c15808c3d2b.png";